import React, { useState } from 'react'
import { get } from 'aws-amplify/api'
import { useAuth0 } from '@auth0/auth0-react'

import OnboardingContext from '../context/OnboardingContext'

const OnboardingProvider = ({ children }) => {
  const [currentView, setCurrentView] = useState(undefined)
  const [countStepper, setCountStepper] = useState(0)
  const { getIdTokenClaims } = useAuth0()
  const baseUrl = process.env.REACT_APP_API_BASE_URL

  const getQuestions = async () => {
    try {
      const idToken = await getIdTokenClaims()
      const resp = get({
        apiName: baseUrl,
        path: '/getOnboardingInfo',
        options: {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${idToken.__raw}`
          }
        }
      })
      const { body } = await resp.response
      const data = await body.json()
      return data
    } catch (error) {
      console.log(error)
    }
  }

  const changeCountStepper = (type, step) => {
    switch (type) {
      case 'forward':
        return setCountStepper(step + 1)
      case 'backward':
        return setCountStepper(step - 1)
      default:
        break
    }
  }

  return (
    <OnboardingContext.Provider
      value={{
        getQuestions,
        currentView,
        setCurrentView,
        countStepper,
        setCountStepper,
        changeCountStepper
      }}
    >
      {children}
    </OnboardingContext.Provider>
  )
}

export default OnboardingProvider
